import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'
import { compartmentReceive } from '../patientActions.js'

export const SHOW_CLOSEABLE_ISSUES_WARNING_MODAL =
  'igao/SHOW_CLOSEABLE_ISSUES_WARNING_MODAL'
export const CLOSE_CLOSEABLE_ISSUES_WARNING_MODAL =
  'igao/CLOSE_CLOSEABLE_ISSUES_WARNING_MODAL'
export const SHOW_SIDEBAR = 'igao/SHOW_SIDEBAR'
export const CLOSE_SIDEBAR = 'igao/CLOSE_SIDEBAR'
export const TOGGLE_SIDEBAR_FILTER = 'igao/TOGGLE_SIDEBAR_FILTER'

export function showCloseableIssuesWarningModal (carePlanIds) {
  return {
    type: SHOW_CLOSEABLE_ISSUES_WARNING_MODAL,
    carePlanIds
  }
}

export function closeCloseableIssuesWarningModal () {
  return {
    type: CLOSE_CLOSEABLE_ISSUES_WARNING_MODAL
  }
}

export function updateIssue (carePlanAndGoal) {
  return dispatch => {
    const patientId = carePlanAndGoal.issue.subject.reference.split('/')[1]
    return http
      .putRequest(
        `/patients/${patientId}/issues/${carePlanAndGoal.issue.id}`,
        carePlanAndGoal
      )
      .then(() => {
        dispatch(compartmentReceive(patientId))
        dispatch(notify('Issue updated successfully.', false))
      })
      .catch(() => {
        dispatch(notify('Issue updated failed with server error.', true))
      })
  }
}

export function createIssues (carePlansAndGoals, patientId, clientName) {
  return (dispatch, getState) => {
    const {
      patient: { compartment }
    } = getState()
    return http
      .postRequest(`/patients/${patientId}/issues`, carePlansAndGoals, {
        clientName
      })
      .then(() => {
        if (compartment) {
          dispatch(compartmentReceive(patientId))
        }
        dispatch(notify('Issue created successfully.', false))
      })
  }
}

export function showSidebar () {
  return {
    type: SHOW_SIDEBAR
  }
}

export function closeSidebar () {
  return {
    type: CLOSE_SIDEBAR
  }
}

export function toggleSidebarFilter (filter) {
  return {
    type: TOGGLE_SIDEBAR_FILTER,
    filter
  }
}
